import { axiosCore } from './http-core-service';
import { ResultSearchDto } from './dtos/result-search.dto';
import { DecisionDeliberationDto } from './dtos/decision-deliberation.dto';
import { SearchDocumentsDto } from './dtos/documents.dto';

/**
 * Méthode qui récupère les documents pour un mandat
 * @return des documents
 */
export const searchDocumentsFromService = async (
    data: SearchDocumentsDto
): Promise<ResultSearchDto<DecisionDeliberationDto>> => {
    // Récupération
    const criterions: string = getCriterions(data);

    // Création d'un json pour la requête
    const response = await axiosCore.get(
        `/api/documents/mandates/${data.mandateId}/search?page=${data.page + 1}&itemsPerPage=${
            data.itemsPerPage
        }${criterions}`
    );

    return response.data;
};

export const getDocumentContentFromService = async (
    mandateId: string,
    gouvernanceDocumentId: string
): Promise<Blob> => {
    const response = await axiosCore.get(
        `/api/documents/mandates/${mandateId}/gouvernance/${gouvernanceDocumentId}/content`,
        { responseType: 'blob' }
    );

    return response.data;
};

/**
 * Méthode qui récupère les critères dans un string
 * @return string
 */
export const getCriterions = (data: SearchDocumentsDto): string => {
    let criterions = '';
    //si recherche par année
    if (data.paramType) {
        criterions += `&type=${data.paramType}`;
    }
    //si recherche par année
    if (data.paramYear) {
        criterions += `&year=${data.paramYear}`;
    }
    //si recherche par mois
    if (data.paramMonth) {
        criterions += `&month=${data.paramMonth}`;
    }
    //si recherche par date début
    if (data.paramStartDate) {
        criterions += `&startDate=${data.paramStartDate}`;
    }
    //si recherche par date fin
    if (data.paramEndDate) {
        criterions += `&endDate=${data.paramEndDate}`;
    }
    //si recherche par nom
    if (data.paramName) {
        criterions += `&name=${data.paramName}`;
    }
    //si recherche par sous catégorie
    if (data.paramSubCategory) {
        criterions += `&subcategory=${data.paramSubCategory}`;
    }
    //si recherche par num
    if (data.paramNumber) {
        criterions += `&number=${data.paramNumber}`;
    }
    //Tri
    if (data.sort) {
        criterions += `&sort=${data.sort}`;
    }
    //Ordre du tri
    if (data.sort && data.order) {
        criterions += `&${data.order}=${data.sort}`;
    }

    return criterions;
};
